import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import Vue from 'vue'

export const NAMESPACE = 'filters/'

const _types = {
  getters: {
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    STORE_FILTERS: 'GETTER_STORE_FILTERS',
    PRODUCT_FILTERS: 'GETTER_PRODUCT_FILTERS',
    HIERARCHY_BY_FILTER: 'GETTER_HIERARCHY_BY_FILTER'
  },
  actions: {
    SET_SELECTED_FILTERS: 'SET_SELECTED_FILTERS',
    RESET_SELECTED_FILTERS: 'RESET_SELECTED_FILTERS',
    REMOVE_SELECTED_FILTER_IN_CASCADE: 'REMOVE_SELECTED_FILTER_IN_CASCADE'
  },
  mutations: {
    SELECTED_STORE_FILTERS: 'MUTATE_SELECTED_STORE_FILTERS',
    SELECTED_PRODUCT_FILTERS: 'MUTATE_SELECTED_PRODUCT_FILTERS',
    ADD_SELECTED_FILTER: 'MUTATE_ADD_SELECTED_FILTER',
    REMOVE_SELECTED_FILTER: 'MUTATE_REMOVE_SELECTED_FILTER',
    PUSH_ASYNC_PRODUCT_TO_POOL: 'PUSH_ASYNC_PRODUCT_TO_POOL'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const Filters = {
  namespaced: true,
  state: () => ({
    selectedStoreFilters: {},
    selectedProductFilters: {},
    asyncProductPool: []
  }),
  getters: {
    [_types.getters.HAS_SELECTED_FILTERS]: (state) => {
      const filters = { ...state.selectedStoreFilters, ...state.selectedProductFilters }
      for (const filter in filters) {
        if (filters[filter].length > 0) return true
      }
      return false
    },
    [_types.getters.STORE_FILTERS]: (state, getters, rootState, rootGetters) => {
      return rootGetters.storeFilters
    },
    [_types.getters.PRODUCT_FILTERS]: (state, getters, rootState, rootGetters) => {
      return rootGetters.productCategoryFilters
    },
    [_types.getters.HIERARCHY_BY_FILTER]: (state, getters) => (filter) => {
      let getterName
      if (filter.keyFieldType === 'store') getterName = _types.getters.STORE_FILTERS
      else if (filter.keyFieldType === 'product') getterName = _types.getters.PRODUCT_FILTERS
      else throw Error(`Tipo de filtro ${filter.keyFieldType} no implementado`)
      return getters[getterName].find((hierarchy) => hierarchy.levelList.map((level) => level.id).includes(filter.keyField))
    }
  },
  actions: {
    [_types.actions.SET_SELECTED_FILTERS] ({ commit }, { productFilters = {}, storeFilters = {}, asyncProductPool = {} }) {
      commit(_types.mutations.SELECTED_STORE_FILTERS, storeFilters)
      commit(_types.mutations.SELECTED_PRODUCT_FILTERS, productFilters)
      commit(_types.mutations.PUSH_ASYNC_PRODUCT_TO_POOL, asyncProductPool)
    },
    [_types.actions.RESET_SELECTED_FILTERS] ({ commit }) {
      commit(_types.mutations.SELECTED_STORE_FILTERS, {})
      commit(_types.mutations.SELECTED_PRODUCT_FILTERS, {})
    },
    // Necesario para el caso de los filtros dependientes
    [_types.actions.REMOVE_SELECTED_FILTER_IN_CASCADE] ({ commit, getters, dispatch }, filter) {
      commit(_types.mutations.REMOVE_SELECTED_FILTER, filter)
      const targetHierarchy = getters[_types.getters.HIERARCHY_BY_FILTER](filter)
      if (!targetHierarchy) return

      const childLevelId = targetHierarchy.levelList.find(x => x.id === filter.keyField).options[0].child_level_id
      const hasChild = childLevelId !== 'None' && childLevelId !== null
      if (hasChild) {
        dispatch(_types.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, { ...filter, keyField: childLevelId })
      }
    }
  },
  mutations: {
    [_types.mutations.SELECTED_STORE_FILTERS] (state, selectedStoreFilters) {
      state.selectedStoreFilters = selectedStoreFilters
    },
    [_types.mutations.SELECTED_PRODUCT_FILTERS] (state, selectedProductFilters) {
      state.selectedProductFilters = selectedProductFilters
    },
    [_types.mutations.PUSH_ASYNC_PRODUCT_TO_POOL] (state, selectedAsyncProduct) {
      state.asyncProductPool = state.asyncProductPool.concat(selectedAsyncProduct)
    },
    [_types.mutations.ADD_SELECTED_FILTER] (state, filter) {
      if (filter.keyFieldType === 'store') Vue.set(state.selectedStoreFilters, filter.keyField, filter.value)
      if (filter.keyFieldType === 'product') Vue.set(state.selectedProductFilters, filter.keyField, filter.value)
    },
    [_types.mutations.REMOVE_SELECTED_FILTER] (state, filter) {
      if (filter.keyFieldType === 'store') state.selectedStoreFilters[filter.keyField] = []
      if (filter.keyFieldType === 'product') state.selectedProductFilters[filter.keyField] = []
    }
  }
}

export default Filters



// WEBPACK FOOTER //
// ./src/app/shared/store/modules/Filters.js